/**
 * iurop-jewel-builder.js — "Crea tu joya" (Apodemia)
 *
 * Base (cadena, radio) + hasta N charms (toggle). El stage pinta la imagen de la
 * cadena con los charms elegidos superpuestos en el colgante. "Añadir al carrito"
 * mete la base + los charms como un combo agrupado (_look) → sidecart.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + n;
  }

  function init(root) {
    if (root.dataset.jbInit === '1') return;
    root.dataset.jbInit = '1';

    var maxCharms = parseInt(root.getAttribute('data-max-charms'), 10) || 3;
    var stage = root.querySelector('[data-jb-stage]');
    var baseImg = root.querySelector('[data-jb-base-img]');
    var charmsLayer = root.querySelector('[data-jb-charms-layer]');
    var stageEmpty = root.querySelector('[data-jb-stage-empty]');
    var baseNote = root.querySelector('[data-jb-base-note]');
    var charmNote = root.querySelector('[data-jb-charm-note]');
    var totalEl = root.querySelector('[data-jb-total]');
    var installEl = root.querySelector('[data-jb-installment]');
    var addBtn = root.querySelector('[data-jb-add]');
    var months = parseInt(addBtn && addBtn.getAttribute('data-months'), 10) || 3;

    var baseBtns = Array.prototype.slice.call(root.querySelectorAll('[data-jb-base]'));
    var charmBtns = Array.prototype.slice.call(root.querySelectorAll('[data-jb-charm]'));
    var compatNote = root.querySelector('[data-jb-compat-note]');
    var txtIncompatible = root.getAttribute('data-txt-incompatible') || '';
    var txtRemoved = root.getAttribute('data-txt-removed') || '';

    var selBase = null;         // { variant, price, title, img }
    var selCharms = [];         // [{ variant, price, title, img }]
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function data(btn) {
      return {
        variant: btn.getAttribute('data-variant'),
        product: btn.getAttribute('data-product') || '',   // charms: para el cruce de incompatibles
        incompat: btn.getAttribute('data-incompat') || '',  // bases: ids de charms vetados
        price: parseInt(btn.getAttribute('data-price'), 10) || 0,
        title: btn.getAttribute('data-title') || '',
        img: btn.getAttribute('data-img') || '',
        img2: btn.getAttribute('data-img-2') || '',
        isClip: btn.getAttribute('data-is-clip') === 'true',
        clipCompatible: btn.getAttribute('data-clip-compatible') === 'true',
        ax: btn.getAttribute('data-ax'),
        ay: btn.getAttribute('data-ay'),
      };
    }

    // =========================================================================
    // Ancla ULTRA-PRECISA por análisis de imagen (canvas)
    // Las cadenas son PNG siluetados: el punto de colgado REAL es el vértice
    // inferior de la silueta (última fila con píxeles opacos). Se detecta una
    // vez por imagen (caché) y se mapea al stage teniendo en cuenta el
    // object-fit: contain (escala + letterbox). Los charms, a su vez, traen
    // aire transparente arriba: se mide y se recorta (translateY) para que la
    // ANILLA del charm toque la cadena, no su caja. Si el canvas falla (CORS),
    // caída al metacampo ancla_x/y y al --jb-drop del CSS.
    // =========================================================================
    var scanCache = {};
    function scanImage(url, mode) {
      var key = mode + ':' + url;
      if (scanCache[key]) return scanCache[key];
      scanCache[key] = new Promise(function (resolve) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var W = 240;
            var H = Math.max(1, Math.round(im.naturalHeight * (W / im.naturalWidth)));
            var cv = document.createElement('canvas');
            cv.width = W;
            cv.height = H;
            var cx = cv.getContext('2d', { willReadFrequently: true });
            cx.drawImage(im, 0, 0, W, H);
            var d = cx.getImageData(0, 0, W, H).data;
            var A = 40; // umbral alfa: ignora sombras muy tenues
            if (mode === 'vertex') {
              // Perfil inferior de la cadena: para CADA columna, el píxel opaco
              // más bajo. El vértice es la columna con el mínimo más profundo;
              // los charms laterales cuelgan del perfil (la curva real de la V).
              var prof = new Array(W);
              var deepest = -1, deepX = 0;
              for (var x = 0; x < W; x++) {
                prof[x] = -1;
                for (var y = H - 1; y >= 0; y--) {
                  if (d[(y * W + x) * 4 + 3] > A) { prof[x] = y; break; }
                }
                if (prof[x] > deepest) { deepest = prof[x]; deepX = x; }
              }
              if (deepest >= 0) {
                // Centro del vértice: media de las columnas que llegan casi al fondo.
                var s = 0, m = 0;
                for (var x2 = 0; x2 < W; x2++) {
                  if (prof[x2] >= deepest - 2) { s += x2; m++; }
                }
                resolve({
                  x: (m ? s / m : deepX) / W,
                  y: deepest / H,
                  iw: im.naturalWidth,
                  ih: im.naturalHeight,
                  // perfil en fracciones (para colgar charms laterales sobre la curva)
                  prof: Array.prototype.map.call(prof, function (py) { return py < 0 ? -1 : py / H; }),
                  W: W,
                });
                return;
              }
            } else {
              // Charm: aire transparente superior (trim) + centro real en X.
              var top = 0, found = false, minX = W, maxX = 0;
              for (var yy = 0; yy < H && !found; yy++) {
                for (var xx = 0; xx < W; xx++) {
                  if (d[(yy * W + xx) * 4 + 3] > A) { top = yy; found = true; break; }
                }
              }
              for (var y2 = 0; y2 < H; y2++) {
                for (var x2 = 0; x2 < W; x2++) {
                  if (d[(y2 * W + x2) * 4 + 3] > A) {
                    if (x2 < minX) minX = x2;
                    if (x2 > maxX) maxX = x2;
                  }
                }
              }
              resolve(found ? { trim: top / H, cx: (minX + maxX) / 2 / W } : null);
              return;
            }
            resolve(null);
          } catch (e) { resolve(null); }
        };
        im.onerror = function () { resolve(null); };
        im.src = url;
      });
      return scanCache[key];
    }

    // ---- Colocación individual: cada charm cuelga de la CURVA de la cadena ----
    // El central en el vértice; los laterales, desplazados en X, cuelgan del
    // perfil inferior real a esa altura (más arriba, siguiendo la V). Todo en %
    // del stage (resistente a resize).
    var lastAnchor = null;

    // Un producto puede representar varias piezas fisicas. Se dibujan todas,
    // pero la seleccion, el precio y la linea de carrito siguen siendo una sola.
    function selectedVisuals() {
      var visuals = [];
      selCharms.forEach(function (c) {
        visuals.push({ key: c.variant + ':1', charm: c, img: c.img });
        if (c.img2) visuals.push({ key: c.variant + ':2', charm: c, img: c.img2 });
      });
      return visuals;
    }

    // Perfil inferior en una fracción X (con ventana: la anilla se apoya en el
    // punto más bajo del eslabón que tenga debajo, y así se salta huecos).
    function profileAt(anchor, xFrac) {
      if (!anchor.prof) return anchor.y;
      var c = Math.round(xFrac * (anchor.W - 1));
      var lo = Math.max(0, c - 4), hi = Math.min(anchor.W - 1, c + 4);
      var best = -1;
      for (var i = lo; i <= hi; i++) {
        if (anchor.prof[i] > best) best = anchor.prof[i];
      }
      return best >= 0 ? best : anchor.y;
    }

    function placeCharms() {
      var sw = stage.clientWidth, sh = stage.clientHeight;
      if (!sw || !sh) return;
      var els = selectedVisuals().map(function (v) { return charmEls[v.key]; }).filter(Boolean);
      var n = els.length;
      if (!n) return;

      // Ancho de cada charm según cuántos hay (en % del stage).
      var wPct = n === 1 ? 20 : n === 2 ? 18 : 15.5;

      if (lastAnchor) {
        var a = lastAnchor;
        var scale = Math.min(sw / a.iw, sh / a.ih);
        var dw = a.iw * scale, dh = a.ih * scale;
        var ox = (sw - dw) / 2, oy = (sh - dh) / 2;
        // Separación horizontal entre anillas: un poco más que media anchura
        // de charm (cuerpos solapados ligeramente). En modo RECOGIDO (hover),
        // todos se apiñan en la anilla del vértice, como charms de verdad.
        var stepPx = (wPct / 100) * sw * (gathered ? 0.15 : 0.62);
        els.forEach(function (el, i) {
          var off = (i - (n - 1) / 2) * stepPx;             // px respecto al vértice
          var xPx = ox + a.x * dw + off;
          var yPx;
          if (gathered) {
            yPx = oy + a.y * dh - 6;                         // todos en el vértice
          } else {
            var xFrac = (xPx - ox) / dw;                     // de vuelta a fracción de imagen
            yPx = oy + profileAt(a, xFrac) * dh - 6;         // -6px: la anilla pisa la cadena
          }
          el.style.setProperty('--jb-x', (xPx / sw * 100) + '%');
          el.style.setProperty('--jb-y', (yPx / sh * 100) + '%');
          el.style.setProperty('--jb-w', wPct + '%');
          // Abanico: sutil colgando de la curva; abierto al apiñarse en la anilla.
          var fan = n > 1 ? ((i - (n - 1) / 2) * (gathered ? 10 : 3.5)) + 'deg' : '0deg';
          el.querySelector('img').style.setProperty('--jb-fan', fan);
        });
      } else if (selBase && selBase.ax) {
        // Fallback sin análisis: metacampo ancla_x/y, en fila plana.
        els.forEach(function (el, i) {
          var off = (i - (n - 1) / 2) * wPct * 0.62;
          el.style.setProperty('--jb-x', (parseFloat(selBase.ax) + off) + '%');
          el.style.setProperty('--jb-y', selBase.ay + '%');
          el.style.setProperty('--jb-w', wPct + '%');
        });
      }
    }
    window.addEventListener('resize', placeCharms);

    // ---- Hover en la joya: los charms se RECOGEN en la anilla del vértice ----
    // (como en la vida real, que se juntan los tres). Solo puntero fino; las
    // transiciones de left/top hacen el viaje y un balanceo corto lo remata.
    var gathered = false;
    function setGather(on) {
      if (gathered === on || selectedVisuals().length < 2) { gathered = on; return; }
      gathered = on;
      placeCharms();
      if (!reduceMotion.matches) {
        charmsLayer.classList.remove('is-swinging');
        void charmsLayer.offsetWidth;
        charmsLayer.classList.add('is-swinging');
        setTimeout(function () { charmsLayer.classList.remove('is-swinging'); }, 950);
      }
    }
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      stage.addEventListener('mouseenter', function () { setGather(true); });
      stage.addEventListener('mouseleave', function () { setGather(false); });
    }

    // ---- Stage: cadena con crossfade + charms con caída y balanceo ----
    var ghost = document.createElement('img');
    ghost.className = 'apodemia-jb__base-img apodemia-jb__base-ghost';
    ghost.alt = '';
    ghost.hidden = true;
    baseImg.insertAdjacentElement('afterend', ghost);

    var lastBaseUrl = null;
    var swapToken = 0;
    var ghostTimer = 0;
    function hideGhost() {
      ghost.hidden = true;
      ghost.classList.remove('is-fading');
    }
    function setBase() {
      if (!selBase) {
        lastBaseUrl = null;
        baseImg.hidden = true;
        baseImg.removeAttribute('src');
        ghost.hidden = true;
        if (stageEmpty) stageEmpty.hidden = false;
        return;
      }
      if (stageEmpty) stageEmpty.hidden = true;
      if (selBase.img === lastBaseUrl) return;
      var prevUrl = lastBaseUrl;
      lastBaseUrl = selBase.img;
      var token = ++swapToken;
      var url = selBase.img;

      // La cadena nueva se PRECARGA y decodifica entera (más su escaneo, en
      // paralelo) ANTES de tocar el DOM: la vieja se queda quieta y el
      // crossfade completo arranca en un solo frame. Sin esto, la nueva se
      // veía "pintándose" en streaming de arriba abajo (parpadeo raro).
      var pre = new Image();
      pre.src = url; // misma clave de caché que baseImg (sin crossOrigin)
      var loaded = pre.decode ? pre.decode().catch(function () {}) : Promise.resolve();

      Promise.all([scanImage(url, 'vertex'), loaded]).then(function (res) {
        if (token !== swapToken) return; // llegó otra cadena por el camino

        // Fantasma: retiene la anterior SOLO durante el crossfade.
        clearTimeout(ghostTimer);
        if (prevUrl && !reduceMotion.matches && baseImg.src) {
          ghost.src = baseImg.src;
          ghost.hidden = false;
          ghost.classList.remove('is-fading');
        } else {
          ghost.hidden = true;
        }

        baseImg.classList.add('is-entering');
        baseImg.hidden = false;
        baseImg.src = url; // instantáneo: ya está en caché y decodificada

        lastAnchor = res[0] || null;
        placeCharms();

        // fuerza layout con el estado inicial y dispara la transición
        void baseImg.offsetWidth;
        baseImg.classList.remove('is-entering');
        if (!ghost.hidden) {
          ghost.classList.add('is-fading');
          ghostTimer = setTimeout(hideGhost, 520);
        }

        // Los charms se re-cuelgan: balanceo pendular al moverse el ancla.
        if (!reduceMotion.matches && selCharms.length) {
          charmsLayer.classList.remove('is-swinging');
          void charmsLayer.offsetWidth;
          charmsLayer.classList.add('is-swinging');
          setTimeout(function () { charmsLayer.classList.remove('is-swinging'); }, 950);
        }
      });
    }

    // Charms por diff (no se reconstruye la capa: los que quedan no parpadean).
    var charmEls = {};
    function syncCharms() {
      var want = {};
      var visuals = selectedVisuals();
      visuals.forEach(function (v) { want[v.key] = true; });
      Object.keys(charmEls).forEach(function (v) {
        if (!want[v]) {
          var el = charmEls[v];
          delete charmEls[v];
          if (reduceMotion.matches) { el.remove(); return; }
          el.classList.add('is-leaving');
          setTimeout(function () { el.remove(); }, 280);
        }
      });
      visuals.forEach(function (v) {
        var c = v.charm;
        if (charmEls[v.key]) return;
        // wrapper (posición) > swing (animaciones) > img (recortes del siluetado)
        var wrap = document.createElement('span');
        wrap.className = 'apodemia-jb__charm-overlay';
        var swing = document.createElement('span');
        swing.className = 'apodemia-jb__charm-swing' + (reduceMotion.matches ? '' : ' is-new');
        var im = document.createElement('img');
        im.alt = '';
        im.src = v.img;
        swing.appendChild(im);
        wrap.appendChild(swing);
        swing.addEventListener('animationend', function () { swing.classList.remove('is-new'); }, { once: true });
        charmEls[v.key] = wrap;
        // Recorte del aire transparente: la anilla toca la cadena.
        scanImage(v.img, 'trim').then(function (t) {
          if (!t) return;
          im.style.setProperty('--jb-trim', t.trim);
          im.style.setProperty('--jb-cx', t.cx);
        });
      });
      // Orden del DOM = orden de selección.
      visuals.forEach(function (v) {
        if (charmEls[v.key]) charmsLayer.appendChild(charmEls[v.key]);
      });
      charmsLayer.setAttribute('data-count', String(visuals.length));
      placeCharms();
    }

    function renderStage() {
      setBase();
      syncCharms();
    }

    // ---- Precio ----
    function totalCents() {
      var t = selBase ? selBase.price : 0;
      selCharms.forEach(function (c) { t += c.price; });
      return t;
    }
    function renderPrice() {
      var t = totalCents();
      totalEl.textContent = formatMoney(t);
      if (installEl) installEl.textContent = formatMoney(Math.round(t / months));
      addBtn.disabled = !selBase;
    }

    // ---- Notas / contadores ----
    function renderNotes() {
      if (baseNote) baseNote.textContent = selBase ? (selBase.title + ' +' + formatMoney(selBase.price)) : '';
      if (charmNote) {
        charmNote.textContent = selCharms.length
          ? (selCharms.length + (selCharms.length === 1 ? ' charm' : ' charms') + ' +' + formatMoney(selCharms.reduce(function (a, c) { return a + c.price; }, 0)))
          : '';
      }
      // Lista de elegidos con nombre y precio (como el "picked" de crea-tu-combo).
      var pickedEl = root.querySelector('[data-jb-picked]');
      if (pickedEl) {
        pickedEl.innerHTML = '';
        selCharms.forEach(function (c) {
          var li = document.createElement('li');
          li.textContent = c.title + ' · +' + formatMoney(c.price);
          pickedEl.appendChild(li);
        });
        pickedEl.hidden = !selCharms.length;
      }
    }

    function refresh() { renderStage(); renderPrice(); renderNotes(); }

    // =========================================================================
    // Charms incompatibles con la cadena elegida
    // Cada base trae data-incompat="idProducto,idProducto…" (metacampo
    // base.charms_incompatibles). Al elegir la cadena, esos charms quedan
    // deshabilitados, se sueltan si estaban puestos y su categoría se oculta si
    // se queda entera sin charms disponibles.
    // =========================================================================
    var noteTimer = 0;
    function showCompatNote() {
      if (!compatNote || !txtRemoved) return;
      compatNote.textContent = txtRemoved;
      compatNote.hidden = false;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { compatNote.hidden = true; }, 6000);
    }

    function applyCompat() {
      var raw = (selBase && selBase.incompat) || '';
      var blocked = {};
      raw.split(',').forEach(function (id) {
        id = id.trim();
        if (id) blocked[id] = true;
      });
      var clipAllowed = !!(selBase && selBase.clipCompatible);

      function isBlockedCharm(btn) {
        var blockedByList = !!blocked[btn.getAttribute('data-product')];
        var blockedClip = btn.getAttribute('data-is-clip') === 'true' && !clipAllowed;
        return blockedByList || blockedClip;
      }

      // 1) Deshabilita / rehabilita cada charm.
      charmBtns.forEach(function (btn) {
        var off = isBlockedCharm(btn);
        btn.disabled = off;
        btn.classList.toggle('is-incompatible', off);
        btn.setAttribute('aria-disabled', off ? 'true' : 'false');
        if (off) {
          if (!btn.hasAttribute('data-tip-base')) btn.setAttribute('data-tip-base', btn.getAttribute('data-tip') || '');
          if (txtIncompatible) btn.setAttribute('data-tip', txtIncompatible);
        } else if (btn.hasAttribute('data-tip-base')) {
          btn.setAttribute('data-tip', btn.getAttribute('data-tip-base'));
        }
      });

      // 2) Suelta los que estuvieran elegidos y ahora no valen.
      var dropped = 0;
      selCharms = selCharms.filter(function (c) {
        if (!blocked[c.product] && (!c.isClip || clipAllowed)) return true;
        dropped++;
        var b = charmBtns.filter(function (x) { return x.getAttribute('data-variant') === c.variant; })[0];
        if (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); }
        return false;
      });
      if (dropped) showCompatNote();
      else if (compatNote) compatNote.hidden = true;

      // 3) Categorías que se quedan sin ningún charm disponible → fuera.
      root.querySelectorAll('[data-jb-cat]').forEach(function (cat) {
        var all = cat.querySelectorAll('[data-jb-charm]');
        var usable = cat.querySelectorAll('[data-jb-charm]:not(.is-incompatible)');
        cat.hidden = all.length > 0 && usable.length === 0;
      });
    }

    // ---- Selección de base ----
    baseBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        baseBtns.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        selBase = data(btn);
        applyCompat();
        refresh();
      });
    });

    // ---- Selección de charms (toggle, máx N) ----
    charmBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = data(btn);
        var idx = selCharms.findIndex(function (c) { return c.variant === d.variant; });
        if (idx > -1) {
          selCharms.splice(idx, 1);
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-pressed', 'false');
        } else {
          if (selCharms.length >= maxCharms) {
            root.classList.add('is-charm-max');
            setTimeout(function () { root.classList.remove('is-charm-max'); }, 600);
            return;
          }
          selCharms.push(d);
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
        }
        refresh();
      });
    });

    // ---- Acordeones de categoría ----
    root.querySelectorAll('[data-jb-cat-toggle]').forEach(function (head) {
      head.addEventListener('click', function () {
        var open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        var body = head.parentElement.querySelector('[data-jb-cat-body]');
        if (body) body.hidden = open;
      });
    });

    // ---- Añadir al carrito (combo) ----
    addBtn.addEventListener('click', function () {
      if (!selBase || addBtn.classList.contains('is-loading')) return;
      var items = [];
      var label = (root.querySelector('.apodemia-jb__title') || {}).textContent || 'Crea tu joya';
      label = label.trim();
      var props = { _look: label + ' · ' + Date.now().toString(36), _look_img: selBase.img };
      items.push({ id: parseInt(selBase.variant, 10), quantity: 1, properties: props });
      selCharms.forEach(function (c) {
        items.push({ id: parseInt(c.variant, 10), quantity: 1, properties: props });
      });
      addBtn.classList.add('is-loading');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          addBtn.classList.remove('is-loading');
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, source: 'jewel-builder' } }));
        })
        .catch(function () { addBtn.classList.remove('is-loading'); });
    });

    refresh();
  }

  function boot() { document.querySelectorAll('[data-jewel-builder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-jewel-builder]');
    if (r) init(r);
  });
})();
